/**
 * @fileoverview GET handler for the "/:app_group_id/knowledge_source/definition/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { knowledgeSourceDefinitionId } from "./constants";
import type { KnowledgeSourceDefinitionIdResult } from "./types";
import { isKnowledgeSourceDefinitionIdResult } from "./validators";

export const getKnowledgeSourceDefinitionId = reactQueryFetcherAdapter(
  knowledgeSourceDefinitionId,
  (signal: AbortSignal, appGroupId: string, definitionId: string): Promise<KnowledgeSourceDefinitionIdResult> => {
    return fetch(`/${appGroupId}/knowledge_source/definition/${definitionId}`, "GET", {}, { signal });
  },
  isKnowledgeSourceDefinitionIdResult
);
